import { gql } from '@apollo/client';

// OTRIX Play — vistas del coach (admin/entrenador) sobre clientes Play.

export const PLAY_CLIENTS = gql`
  query playClients($search: String, $first: Int) {
    playClients(search: $search, first: $first) {
      id
      first_name
      last_name
      full_name
      email
      photo
      is_online
    }
  }
`;

export const CLIENT_PLAY_SUMMARY = gql`
  query clientPlaySummary($user_id: ID!) {
    clientPlaySummary(user_id: $user_id) {
      user_id
      workouts_total
      workouts_this_month
      adherence_percent
      current_streak_days
      total_seconds
      avg_completion_percent
      last_workout_at
      muscle_distribution {
        muscle_group
        count
        percent
      }
    }
  }
`;

export const CLIENT_PLAY_WORKOUTS = gql`
  query clientPlayWorkouts($user_id: ID!, $first: Int) {
    clientPlayWorkouts(user_id: $user_id, first: $first) {
      id
      day_of_week
      muscle_focus
      started_at
      completed_at
      total_seconds
      total_sets
      estimated_calories
      completion_percent
      status
      created_at
    }
  }
`;

export const CLIENT_WEEKLY_ROUTINE = gql`
  query clientWeeklyRoutine($user_id: ID!) {
    clientWeeklyRoutine(user_id: $user_id) {
      id
      name
      items {
        id
        day_of_week
        position
        target_sets
        target_reps
        exercise {
          id
          name
          localized_name
          muscle_group
          image_url_1
          image_url_2
        }
      }
    }
  }
`;
